import { Platform, Linking, Alert, Share } from 'react-native'

/**
 * Condivide un file usando la Share API nativa di React Native.
 * Su web fallback al download.
 */
export async function shareOrDownloadFile(blob, fileName, shareData = {}) {
  if (Platform.OS === 'web') {
    // Web: stesso comportamento del progetto precedente
    const file = new File([blob], fileName, { type: blob.type })
    if (
      typeof navigator !== 'undefined' &&
      navigator.share &&
      navigator.canShare?.({ files: [file] })
    ) {
      await navigator.share({ title: shareData.title ?? fileName, files: [file] })
      return
    }
    if (typeof document !== 'undefined') {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url; a.download = fileName; a.click()
      URL.revokeObjectURL(url)
    }
    return
  }
  // Mobile nativo: usa Share API
  await Share.share({ message: shareData.text ?? shareData.title ?? fileName })
}

/**
 * Apre un URL esterno.
 */
export function openExternalUrl(url) {
  Linking.openURL(url)
}

/**
 * Mostra una finestra di conferma.
 */
export function showConfirm(message) {
  if (Platform.OS === 'web') {
    return Promise.resolve(window.confirm(message))
  }
  return new Promise((resolve) => {
    Alert.alert('Conferma', message, [
      { text: 'Annulla', onPress: () => resolve(false), style: 'cancel' },
      { text: 'Conferma', onPress: () => resolve(true) },
    ])
  })
}

/**
 * Restituisce l'origin dell'app.
 */
export function getAppOrigin() {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    return window.location.origin
  }
  return 'https://app.virtuacycling.com'
}

/**
 * Rileva se il dispositivo � iOS.
 */
export function isIOSDevice() {
  return Platform.OS === 'ios'
}

/**
 * Su mobile � sempre true (� un'app nativa).
 */
export function isStandaloneMode() {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    return window.navigator?.standalone === true
  }
  return true
}